/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import { isMobile } from "react-device-detect";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import Event202304_uma_gamecode_show from "./Event202304_uma_gamecode_show";
import Event202305_uma_recall_show from "./Event202305_uma_recall_show";

import "../../css/event20230410.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "../../css/confirm.css";
import moment from "moment";

class Event202305_uma_recall extends Component {
  state = {
    orderCode: "",
    showCode: false,
    addrOrderCode: "",
    addrIdx: 0,
  };
  componentDidMount = () => {
    const { loginId, history } = this.props;

    window.addEventListener("message", this._addr);

    if (loginId === null || loginId === undefined || loginId === "") {
      history.push("/login_recall");
    } else {
      this._getOrderList();
    }
  };
  componentWillUnmount = () => {
    window.removeEventListener("message", this._addr);
  };

  _addr = (e) => {
    const { addrOrderCode } = this.state;
    console.log(e.data);
    const idx = e.data.idx;
    console.log("test.../" + idx + "/" + addrOrderCode);
    if (idx && addrOrderCode !== "") {
      console.log("주소변경 루틴");
      this._updateAddress(addrOrderCode, idx);
      // 주소변경이 끝나면 새로 고침 해야하나....
    }
  };
  _updateAddress = async (orderCode, addrIdx) => {
    const { loginId, pkg, apiUrl, history } = this.props;

    const at = localStorage.getItem("at");
    console.log(orderCode, addrIdx);
    if (loginId === null || loginId === undefined || loginId === "") {
    } else {
      const result = await axios
        .post(
          apiUrl + "/event_uma_gamecode_address_update",
          {
            params: {
              userid: loginId,
              pkg: pkg,
              orderCode: orderCode,
              addrIdx: addrIdx,
            },
          },
          {
            headers: {
              Authorization: "bearer " + at,
            },
          }
        )
        .catch((error) => {
          console.error(error.response.status);
          if (error.response.status === 403) {
            //console.log('refresh....token...')
            this._refreshToken1();
          } else if (error.response.status === 400) {
            history.push("/login");
          }
        });

      const intReturn = result.data[0].intReturn;
      console.log(intReturn + "................");
      if (intReturn === 0) {
        this.setState({
          addrOrderCode: "",
          addrIdx: addrIdx,
        });
        setTimeout(() => {
          this._getOrderList();
        }, 700);
      } else if (intReturn === -4) {
        alert("리콜 기간이 종료되었습니다.");
      } else if (intReturn === -3) {
        alert("존재하지 않는 계정입니다.");
      } else if (intReturn === -2) {
        alert("구매내역이 존재하지 않습니다.");
      } else if (intReturn === -1) {
        alert("이미 리콜이 신처되어있습니다.");
      }
    }
  };
  _openAddress = (orderCode) => {
    this.setState({
      addrOrderCode: orderCode,
    });
    window.open(
      "https://shop.aniplustv.com/popAddr",
      "addr",
      "width=700, height=800"
    );
    console.log(orderCode);
  };
  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _getOrderList = async () => {
    const { loginId, pkg, apiUrl, history } = this.props;
    const at = localStorage.getItem("at");

    if (loginId === null || loginId === undefined || loginId === "") {
    } else {
      const result = await axios
        .post(
          apiUrl + "/event_uma_gamecode_buylist",
          {
            params: {
              userid: loginId,
              pkg: pkg,
            },
          },
          {
            headers: {
              Authorization: "bearer " + at,
            },
          }
        )
        .catch((error) => {
          console.error(error.response.status);
          if (error.response.status === 403) {
            //console.log('refresh....token...')
            this._refreshToken();
          } else if (error.response.status === 400) {
            history.push("/login");
          }
        });

      if (result) {
        console.log("..................");
        const intReturn = result.data[0].intReturn;
        const buyList = result.data[0].listData;
        if (intReturn === 0) {
          this.setState({
            buyList,
          });
        }
      }
    }
  };
  _refreshToken1 = async () => {
    const { gotoPage } = this.state;
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const rt = localStorage.getItem("rt");

    if (rt === "" || rt === undefined || rt === null) {
      history.push("/login");
      return false;
    }

    const { data } = await axios.post(apiUrl + "/refreshToken", {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem("at", data[0].at);
      this._updateAddress();
    } else {
      this.setCookie("account", "");

      setLoginId("");
      setAuthId("");

      setTimeout(() => {
        history.push("/login");
      }, 500);
    }
  };
  _refreshToken = async () => {
    const { gotoPage } = this.state;
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const rt = localStorage.getItem("rt");

    if (rt === "" || rt === undefined || rt === null) {
      history.push("/login");
      return false;
    }

    const { data } = await axios.post(apiUrl + "/refreshToken", {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem("at", data[0].at);
      this._getOrderList();
    } else {
      this.setCookie("account", "");

      setLoginId("");
      setAuthId("");

      setTimeout(() => {
        history.push("/login");
      }, 500);
    }
  };
  _renderItem = () => {
    const { buyList, showCode, orderCode, addrIdx, addrOrderCode } = this.state;
    const list = buyList.map((item) => {
      return (
        <>
          <div className="d_flex">
            <table key={item.orderCode}>
              <caption></caption>
              <colgroup>
                <col style={{ width: "80%" }} />
                <col style={{ width: "20%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>주문번호</th>
                  <th>수량</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{item.orderCode}</td>
                  <td>{item.goodCount}</td>
                </tr>
              </tbody>
            </table>

            <button
              className={item.recall === "Y" ? "btn_codeRE" : "btn_codeR"}
              onClick={() => this._confirm(item.recall, item.orderCode)}
            >
              {item.recall === "Y" ? "리콜완료" : "리콜신청"}
            </button>
          </div>
          <Event202305_uma_recall_show
            orderCode={item.orderCode}
            openAddress={this._openAddress}
            recall={item.recall}
            addrIdx={addrIdx}
            addrOrderCode={addrOrderCode}
          />
          {/* {item.recall === "Y" && orderCode === item.orderCode ? (
            <Event202305_uma_recall_show orderCode={item.orderCode} />
          ) : null} */}
        </>
      );
    });

    return list;
  };
  _confirm = (recall, orderCode) => {
    const today = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

    if (today >= "2023-05-15 00:00:00" && today <= "2023-06-18 23:59:59") {
      if (recall === "N") {
        if (
          window.confirm(
            "리콜을 신청하신 후에는 주소 수정이 불가합니다.\n\n해당 주소지로 리콜을 신청 하시겠습니까?"
          )
        ) {
          this._checkCode(orderCode);
        }
      }
    } else {
      alert("리콜 신청기간이 종료되었습니다.");
    }
  };
  _checkCode = async (orderCode) => {
    const { loginId, pkg, apiUrl, history } = this.props;
    const at = localStorage.getItem("at");

    if (loginId === null || loginId === undefined || loginId === "") {
    } else {
      const result = await axios
        .post(
          apiUrl + "/event_uma_gamecode_recallConfirm",
          {
            params: {
              userid: loginId,
              pkg: pkg,
              orderCode: orderCode,
            },
          },
          {
            headers: {
              Authorization: "bearer " + at,
            },
          }
        )
        .catch((error) => {
          console.error(error.response.status);
          if (error.response.status === 403) {
            //console.log('refresh....token...')
            this._refreshToken();
          } else if (error.response.status === 400) {
            history.push("/login");
          }
        });

      if (result) {
        const intReturn = result.data[0].intReturn;
        if (intReturn === 0 || intReturn === 1) {
          //게임코드 보여주기.
          this.setState({
            orderCode,
            showCode: true,
          });
          this._getOrderList();
        } else if (intReturn === -4) {
          alert("리콜 기간이 종료되었습니다.");
        } else {
          alert("구매내역이 존재하지 않거나 오류가 발생했습니다.");
        }
      }
    }
  };
  render() {
    const { imgUrl, loginId, nicName } = this.props;
    const { buyList, orderCode, showCode } = this.state;

    return (
      <Fragment>
        <div className="evt_wrap">
          <div className="evt_1">
            <img src="/img/event/event20230410/evt_11_1.png" alt="" />
          </div>
          <div className="codeView">
            <dl>
              <dt>닉네임</dt>
              <dd>{nicName}</dd>
              <dt style={{ marginLeft: 5 }}>ID</dt>
              <dd>{loginId}</dd>
            </dl>
            {buyList ? (
              <>
                {this._renderItem()}
                {/* {showCode ? (
                  <Event202304_uma_gamecode_show orderCode={orderCode} />
                ) : null} */}
              </>
            ) : (
              <div className="d_flex">
                <div
                  style={{
                    fontSize: 18,
                    textAlign: "center",
                    width: "100%",
                    paddingTop: 30,
                    color: "#ff5d24",
                  }}
                >
                  구매내역이 존재하지 않습니다.
                </div>
              </div>
            )}
          </div>
          {/* <div className="evt_2">
            <img src="/img/event/event20230410/evt_2.png" alt="" />
          </div> */}
          <div className="evt_3">
            <img src="/img/event/event20230410/evt_3_1_1.png" alt="" />
          </div>
          <div className="evt_4">
            <img src="/img/event/event20230410/evt_4.png" alt="" />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202305_uma_recall));
